import { TemplateData, TemplateParams } from '.';

const achievementExpired = ({
  defaultPlaceholders,
  messages,
  serverConfig
}: TemplateParams): TemplateData => ({
  category: 'achievements',
  email: {
    buttonEnabled: true,
    buttonLink: '{{achievementUrl}}',
    buttonText: messages.authSignIn,
    content: `
      <p>
        ${messages.achievementExpiredContent}
        ${messages.achievementExpirationInfo}
      </p>`,
    contentAfterButton: `
      <p>
        ${messages.emailSignatureText}
      </p>`,
    footnote: `${messages.emailContentClarification} {{contactEmail}}`,
    heading: messages.emailGreeting,
    subject: `{{siteName}}: ${messages.commonAchievementExpirationExpired}`
  },
  placeholders: {
    achievementTitle: {
      label: messages.achievementTitle,
      example: 'Test achievement'
    },
    achievementUrl: {
      label: messages.achievementLink,
      example: `${serverConfig.adminUrl}/achievements/1`
    },
    ...defaultPlaceholders
  },
  title: messages.emailTypeExternalAchievementExpired
});

export default achievementExpired;
